import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';
import { usePostErrorMessageMutation } from '@greenkub-fronts/data-access';
import {
  addPositiveMessage,
  addSnackMessage,
} from '@greenkub-fronts/domain/snackbar';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from './error-boundary';

export interface ErrorBoundaryUIProps {
  error: Error;
  currentLocation: string | undefined;
  resetErrorBoundary: Function;
}

export function ErrorBoundaryFeature(props: ErrorBoundaryUIProps) {
  const { error, currentLocation, resetErrorBoundary } = props;

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { user, role } = useSelector((state: RootState) => state.auth);
  const auth = useSelector((state: RootState) => state.auth);

  const [postError] = usePostErrorMessageMutation();

  const [isMoreDetails, setIsMoreDetails] = useState<boolean>(true);

  useEffect(() => {
    postError({
      data: {
        state: JSON.stringify({ auth: { ...auth, user: undefined } }),
        location: currentLocation,
        message: error.stack,
      },
    })
      .then(() => {
        dispatch(
          addPositiveMessage(
            " L'erreur a été envoyée au service informatique. "
          )
        );
      })
      .catch((error: Error) => {
        dispatch(addSnackMessage('negative', error.message));
      });
  }, [error.stack]);

  const buttonReturnHandler = () => {
    navigate(-1);
    navigate(window.location.href);
    resetErrorBoundary();
  };

  return (
    <ErrorBoundary
      user={user}
      role={role}
      navigate={navigate}
      error={error}
      currentLocation={currentLocation}
      buttonReturnHandler={buttonReturnHandler}
      resetErrorBoundary={resetErrorBoundary}
      setIsMoreDetails={setIsMoreDetails}
      isMoreDetails={isMoreDetails}
    />
  );
}

export default ErrorBoundaryFeature;
